// Npm
import { Button, Footer as XPSFooter, Loader } from '@nt/dds-react';
import React, { Suspense, useState } from 'react';

// Local
import { FooterLinkTypes, FormatMessage } from '../../utils/types';
import Modal from '../common/Modal';
import { formatMessageHOC } from '../Hoc/formatMessageHOC';
import './Footer.css';

const WealthPassport = React.lazy(() => import('./FooterModal/WealthPassport'));
const BillPay = React.lazy(() => import('./FooterModal/BillPay'));
const PrivacyPolicy = React.lazy(() => import('./FooterModal/PrivacyPolicy'));
const OnlineServices = React.lazy(() => import('./FooterModal/OnlineServices'));

interface Props extends FormatMessage {}
const Footer: React.FC<Props> = ({ f }) => {
  const [footerType, setFooterType] = useState<string>('');

  return (
    <>
      <XPSFooter
        copyrightText=""
        className="padding-none margin-none border-top"
        content={
          <div className="footer-wrap">
            <ul className="footer-list">
              <li>{f({ id: 'footer.link.copyRight' })}</li>
              <li>
                <Button
                  icon="none"
                  kind="borderless"
                  onClick={() => {
                    setFooterType(FooterLinkTypes.WEALTH_PASSPORT);
                  }}
                  size="small"
                  type="button"
                  className="action-button footer-link"
                >
                  {f({ id: 'footer.link.wealthPassport' })}
                </Button>
              </li>
              <li>
                <Button
                  icon="none"
                  kind="borderless"
                  onClick={() => {
                    setFooterType(FooterLinkTypes.BILL_PAY);
                  }}
                  size="small"
                  type="button"
                  className="action-button footer-link"
                >
                  {f({ id: 'footer.link.billPay' })}
                </Button>
              </li>
              <li>
                <Button
                  icon="none"
                  kind="borderless"
                  onClick={() => {
                    setFooterType(FooterLinkTypes.PRIVACY_POLICY);
                  }}
                  size="small"
                  type="button"
                  className="action-button footer-link"
                >
                  {f({ id: 'footer.link.privacyPolicy' })}
                </Button>
              </li>
              <li>
                <Button
                  icon="none"
                  kind="borderless"
                  onClick={() => {
                    setFooterType(FooterLinkTypes.SECURITY_OVERVIEW);
                  }}
                  size="small"
                  type="button"
                  className="action-button footer-link"
                >
                  {f({ id: 'footer.link.onlineServicesSecurityOverview' })}
                </Button>
              </li>
            </ul>
          </div>
        }
      />
      <Modal
        alert={true}
        size="large"
        isOpen={!!footerType}
        header={{
          heading: footerType,
          onClose: () => setFooterType('')
        }}
        footer={{}}
      >
        <div className="modal-content-wrap">
          <Suspense fallback={<Loader ariaLabel="Loading" size="lg" />}>
            {footerType === 'Terms & Conditions - Wealth Passport' && <WealthPassport />}
            {footerType === 'Terms & Conditions - Bill Pay/Zelle' && <BillPay />}
            {footerType === 'Privacy Policy' && <PrivacyPolicy />}
            {footerType === 'Online Services - Security Overview' && <OnlineServices />}
          </Suspense>
        </div>
      </Modal>
    </>
  );
};

Footer.displayName = 'Footer';
export default formatMessageHOC(Footer);
